import { memo, useState } from "react";
import { ArticleIcon, BackBoxIcon, HourglassIcon, IconContract, NewTimerIcon, SolarPowerIcon, VerifiedCircleIcon } from "../../../../assests/icons/Icons";
import { Button } from "../../../../Components/Button";
import { useAppDispatch, useAppSelector } from "../../../../ReduxTool/store/hooks";
import { IconSave } from "../../../../assests/icons/MapToolsIcons";
import { Accordion } from "../NewSiteAnalyze";
import { setModalHeaderFooter } from "../../../../ReduxTool/Slice/CommonReducers/CommonReducers";
import { INSTALLATION_MODE, SUPPORT_EMAIL } from "../../../../Utils/Const";
import { getCurrencyLabel, projectInstallationDays, projectCostBreakdown, formatCompactMoney, formatCompactNumber, formatEnergy, formatEnergyGeneration, formatMoney } from "../../../../Utils/commonFunctions";
import { getProposalFromEpc } from "../../../../ReduxTool/Slice/Consumer/Api";
import { setSeeProposal } from "../../../../ReduxTool/Slice/Consumer/ConsumerReducers";

 export  const ApprovelPayment = memo(() => {
   const dispatch = useAppDispatch();
   const { roofAnalysis: { formDetails: { projectSetup: { lat, lng, address }, projectSetup, error, }, selected_project, isWithRoof, useableArea, obsArea,countryName,regionName } } = useAppSelector(state => state.consumerReducers);
   const [openSubAccordian, setOpenSubAccordian] = useState({finalproposal:true,})
   const { user: { country_mstr,userid },user } = useAppSelector(state => state.auth);
   const { buttonLoader} = useAppSelector((state) => state.commonReducers);
   const costBreakdown = projectCostBreakdown(selected_project);

    const openViewProfileModal = (modalTy: "proposalreview" | null) => {
           let modalHeaderFooter = { title: "", btnTxt: "", secondaryBtnTxt: "",modalid: "",isheader:false}
           dispatch(setModalHeaderFooter(modalHeaderFooter))
           switch (modalTy) {
               case "proposalreview":
               modalHeaderFooter = { title: "Review your proposal", btnTxt: "Continue to Agreement", secondaryBtnTxt: "Talk to Support",modalid: "proposalreview",isheader:true}
               break
               case null:
               modalHeaderFooter = { title: "", btnTxt: "", secondaryBtnTxt: "",modalid: "",isheader:false }
               break;
             default:
               break
           }
           dispatch(setModalHeaderFooter(modalHeaderFooter))
        }
   
    //      if (selected_project?.project_generation_details?.sam_generation) {
    //     console.log("Sam generation from epc --->>> ", selected_project?.project_generation_details?.sam_generation.toFixed(2))
    // }
    // if (selected_project?.project_generation_id) {
    //     console.log("Sam generation id from epc --->>> ", selected_project?.maxplantcapacity)
    // }
   
  //  debugger
  return (
    <><Accordion isDisable={false} isOpen={openSubAccordian.finalproposal} title={"Final Optimized Proposal"} onToggle={()=>setOpenSubAccordian(prev=>({...prev,finalproposal:!prev.finalproposal}))} maxh="fit-content" >
    <div className="max-w-md mx-auto bg-white px-1 font-sans text-[#1a1c1e]">

       { (selected_project?.consumer_mainprojectstatus ?? 0) >=2 && <div className="flex gap-3 p-2 py-3 mb-6 border border-gray-200 rounded-lg "> 
        <div className="mt-1">
          <VerifiedCircleIcon size={18} />
        </div>
        <div>
          <h3 className="text-[14px] font-semibold text-gray-800">
            Your solar journey has begun
          </h3>
          <p className="text-[12px] text-gray-500 mt-1 leading-relaxed">
           Thank you for your trust. Our team is now preparing everything needed to start your installation.
          </p>
        </div>
      </div>}
      
      <div className="mb-1">
        <h4 className="text-base">Your final solar proposal is ready</h4>
      </div>

            <div className="pb-5">
                    <p className="text-[11px] text-[#616161] font-normal font-Roboto mb-2">
                       Review savings and choose how you want to proceed.
                    </p>
 
                    {/* System size */}
                    <div className="flex gap-2 mb-1">
                        <span className="pt-2"><SolarPowerIcon /> </span>
                        <div>
                        <span className="text-[12px] font-inter text-black">Final Plant Size (AC) </span>
                    {/* <p className="text-[20px] font-normal text-custom-primary-default mb-1">{selected_project?.project_generation_details?.sam_generation ? ((+selected_project?.maxplantcapacity)||0)?.toFixed(2) : ((selected_project?.sanctionload))?.toFixed(0) }{` kW`}</p> */}
                    <p className="text-[20px] font-normal text-custom-primary-default mb-1">{ ((selected_project?.plant_ac_capacity))?.toFixed(0) }{` kW`}</p>
                    </div>
                    </div>
     {}
                    <div className="border-t border-b border-gray-200 py-3.5 flex flex-col gap-3 mb-1">
                      <div className="flex justify-between items-center">
                          <span className="text-[12px] font-inters text-black">{"Annual energy generation"}</span> 
                          <span className="text-custom-primary-dark font-medium font-inter text-[14px]">{!selected_project?.project_generation_details?.pvnxt_generation ? `~ ${formatEnergy(+((+selected_project?.yearlygensanctioned!)||0)?.toFixed(2),true)}` :  `~ ${formatEnergy(+((+selected_project?.project_generation_details?.pvnxt_generation!)||0)?.toFixed(0),true)}` }</span>
                      </div>
                      <div className="flex justify-between items-center">
                          <span className="text-[12px] font-inters text-black">{"Total project cost"}</span> 
                          <span className="text-custom-primary-dark font-medium font-inter text-[14px]">{`~ ${getCurrencyLabel(country_mstr)} ${formatCompactNumber((((+selected_project?.projectcost!)||0)  / country_mstr?.currencyrate!),user?.country_mstr?.alpha2code)}`}</span>
                      </div>
                      <div className="flex justify-between items-center">
                          <span className="text-[12px] font-inters text-black">{costBreakdown.isBooked ? "Booking amount paid" : "Upfront payment after subsidy"}</span>
                          {costBreakdown.isBooked
                            ? <span className="text-custom-primary-dark font-medium font-inter text-[14px]">{`~ ${getCurrencyLabel(country_mstr)} ${formatCompactNumber((costBreakdown.booking / country_mstr?.currencyrate!),user?.country_mstr?.alpha2code)}`}</span>
                            : <a href={`mailto:${SUPPORT_EMAIL}?subject=${encodeURIComponent("Upfront payment after subsidy")}`} className="text-[12px] font-medium underline text-[rgba(27,79,216,1)]" title={SUPPORT_EMAIL}>Connect with support team</a>}
                      </div>
                      {costBreakdown.isBooked && <div className="flex justify-between items-center">
                          <span className="text-[12px] font-inters text-black">{"Remaining amount"}</span>
                          <span className="text-custom-primary-dark font-medium font-inter text-[14px]">{`~ ${getCurrencyLabel(country_mstr)} ${formatCompactNumber((costBreakdown.remaining / country_mstr?.currencyrate!),user?.country_mstr?.alpha2code)}`}</span>
                      </div>}
                      <div className="flex justify-between items-center">
                          <span className="text-[12px] font-inters text-black">{"Payback period"}</span>
                          <span className="text-custom-primary-dark font-medium font-inter text-[14px]">{selected_project?.issubscribed ? `~ ${selected_project?.savingperiod??0}` :  `~ ${selected_project?.savingperiod??0}` }{` years`}</span>
                      </div>
                    </div>
 
                    <div className="flex justify-between items-center mt-3">
                      <span className="text-[12px] font-inters text-black flex gap-2 pl-1">{<NewTimerIcon />}{`Installation completes in ${projectInstallationDays(selected_project)} days`}</span>
                      {/* <span className="text-custom-primary-dark font-medium font-inter text-[14px]">{"~₹XX.X Lakh"}</span>  ||||||||    selected_project?.installationmode as INSTALLATION_MODE === "pvNXT Mode" &&   */}
                    </div>
                   {/* {selected_project?.installationmode as INSTALLATION_MODE === "pvNXT Mode" && <div className="flex gap-4 flex-col"> */}
                   {<div className="flex gap-4 flex-col">
                     <Button className="btn btn-sm-outlineprimary w-full mt-4" name={"See Full Proposal"} isLoading={buttonLoader === "seeproposalbuttonloading"} LeftIcon={<ArticleIcon /> } disabled={(selected_project?.proposalfilepath ?? "") === ""} /* disabled={selected_project?.issubscribed ? false : true} */   onClick={()=>dispatch(setSeeProposal(true))} />  
                    {(selected_project?.consumer_mainprojectstatus ?? 0) < 2 && <Button LeftIcon={<BackBoxIcon rotate90/>}   disabled={(selected_project?.proposalfilepath ?? "") === ""}  isLoading={false} className="primary-btn w-full"  name={"Approve Proposal"}  onClick={() => openViewProfileModal("proposalreview")}   />}
                     </div>}
                </div>
    </div>
    </Accordion>
    </>
  );
})

// ()=>getProposalFromEpc(userid,selected_project?.projectid)